import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import { DatePickerField } from "_metronic/_partials/controls";
import RightArrowSvg from "assets/icons/svg/RightArrowSvg";
import { InputField, LabelField, MyCheckbox, SelectField, TextareaField } from "components";
import AlertDialog from "components/Dialog";
import InfoTooltip from "components/InfoTooltip";
import AddInstallmentsPayment from "components/Installments/AddInstallmentsPayment";
import { getDateFormat, getDateFormatForDatePicket, maskDate } from "helper/dateFormat";
import { getCurrency, numberFormat } from "helper/numberFormat";
import { useSearch } from "hook";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import FinanceService from "../../../../Lib/API/Finance";
import { DateFormetContext } from "../../../../app/App";
import { CheckFloatValue } from "../../../../utils/functions";
import FinanceAccordion from "../Accordion";
import { PriceType } from "./PercentageFixed";
import TributeInformation from "./TributeInformation";


const Donation = ({
  types,
  setShow,
  show,
  index,
  removeCharge,
  refresh,
  accountName,
  setAccountName,
  enableInstallments,
  ...props
}) => {
  const [loading, setLoading] = React.useState(false);
  const [taxType, setTaxType] = useState("%");
  const { getAccessTokenSilently } = useAuth0();
  const [search, setSearch] = useState("");
  const { searchAction } = useSearch({ action: setSearch });
  const [data, setData] = useState();
  const [ledgers, setLedgers] = useState();
  const [subLedgerOptions, setSubLedgerOptions] = useState();
  const formik = props;

  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();
  const dateTimeMask = maskDate();
  const currency = getCurrency();


  const { accountTransaction } = useSelector((state) => state.CommonStates);
  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(dateFormate || "mm/dd/yyyy");
  const [PaymentKey, hasPaymentKey] = useState(false);
  const [showShortCut, setShowShortCut] = useState(false);
  const [pendingLedger, setPendingLedger] = useState(null);
  const [showLedgerConfirm, setShowLedgerConfirm] = useState(false);
  const [pendingSubLedger, setPendingSubLedger] = useState(undefined);
  const [showSubLedgerConfirm, setShowSubLedgerConfirm] = useState(false);
  const toValidDate = (val) => { const d = new Date(val); return isNaN(d.getTime()) ? null : d; };
  const [dateRange, setDateRange] = useState([toValidDate(formik?.values?.values?.[0]?.recurringStart), toValidDate(formik?.values?.values?.[0]?.recurringEnd)]);
  const [startDate, endDate] = dateRange;
  const [selectdCycle, setSelectCycle] = useState("");
  const dateFormet = React.useContext(DateFormetContext);
  const [customBol, setCustomBol] = useState(false);

  useEffect(() => {
    if (formik.values.type === "edit-charge") {
      setShowShortCut(false);
    } else {
      formik.setFieldValue(`values.${index}.due_date`, new Date());
    }
  }, [formik.values.type])

  const ShortcutsArr = [
    {
      name: "Forever",
      value: "forever",
    },
    {
      name: "1 cycle",
      value: "1",
    },
    {
      name: "2 cycle",
      value: "2",
    },
    {
      name: "3 cycle",
      value: "3",
    },
    {
      name: "6 cycle",
      value: "6",
    },
    {
      name: "12 cycle",
      value: "12",
    },
    // {
    //   name: "custom",
    // },
  ];

  const DurationValues = [
    {
      label: "Monthly",
      value: "month",
      number: 1,
    },
    {
      label: "Every 3 months",
      value: "quarter",
      number: 3,
    },
    {
      label: "Every 6 months",
      value: "halfYear",
      number: 6,
    },
    {
      label: "Yearly",
      value: "year",
      number: 12,
    },
  ];

  useEffect(() => {
    if (startDate !== null) {
      if (endDate >= new Date()) {
        formik.setFieldValue(`values.${index}.recurringStart`, startDate);
      }
      else {
        formik.setFieldValue(`values.${index}.recurringStart`, startDate);
        setDateRange([startDate, null]);
      }
    }
    if (endDate !== null) {
      if (endDate >= new Date()) {
        formik.setFieldValue(`values.${index}.recurringEnd`, endDate);
      }
      else {
        formik.setFieldValue(`values.${index}.recurringEnd`, endDate);
        setDateRange([startDate, null]);
      }
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (endDate !== null && (endDate <= startDate || endDate <= new Date())) {
      // toastr.error("End date should be more start date");
      setDateRange([startDate, null]);
    }
  }, [endDate]);

  const addMonths = (date, months) => {
    var d = date.getDate();
    var totalMonths = months * formik.values.values?.[index]?.recurring_duration
      ?.number;
    date.setMonth(date.getMonth() + +totalMonths);
    if (date.getDate() != d) {
      date.setDate(0);
    }
    return date;
  };

  useEffect(() => {
    if (selectdCycle) {
      const cycleStart = startDate || new Date();
      if (selectdCycle.value !== "forever") {
        const date = addMonths(new Date(cycleStart), selectdCycle.value);

        if (date) {
          setDateRange([cycleStart, date]);
        }
      } else {
        setDateRange([cycleStart, null]);
      }
    }
  }, [selectdCycle]);

  useEffect(() => {
    if (formik.values.values?.[index]?.recurring_duration && formik.values.type !== "edit-charge") {
      setShowShortCut(true);
    }
  }, [formik.values.values?.[index]?.recurring_duration])

  useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      AuthService.getUserExist(token)
        .then((res) => {
          hasPaymentKey(res?.user?.hasPayment);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
    fetchMyAPI();
  }, []);

  const selectedStatus = localStorage.getItem("TransStatus") !== undefined ? localStorage.getItem("TransStatus") : '';

  const payNowValueData = useSelector(
    (state) => state.homeReducer.payNowValueData
  );

  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  const enableLoading = (value) => {
    setLoading(value);
  };
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  useEffect(() => {
    formik.setFieldValue("type_of_charge", "donation");
    if (formik.values?.nextPayment === false && accountName === true) {
      formik.setFieldValue(`values.${index}.Ledger`, {
        id: "",
        name: "",
      });
      formik.setFieldValue(`values.${index}.SubLedger`, {
        id: "",
        name: "",
      });
      formik.setFieldValue(`values.${index}.due_date`, "");
      formik.setFieldValue(`values.${index}.tax`, "");
      formik.setFieldValue(`values.${index}.total_amount`, "");
      formik.setFieldValue(`values.${index}.discount`, "");
      formik.setFieldValue("note", "");
    }
    if (!!accountTransaction) {
      formik.setFieldValue(`account_name`, {
        id: accountTransaction?._id,
        name: accountTransaction?.family_name,
      });
    }
  }, []);

  useEffect(() => {
    if (payNowValueData) {
      formik.setFieldValue(
        `assign_email`,
        payNowValueData?.tribute_info?.assign_tribute
      );
    }
  }, [payNowValueData]);

  const formatOptionLabel = ({ label, account_id }) => {
    return (
      <div className="dropdown-container" key={account_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const getTaxValue = formik.values.values[index]?.tax ?? 0;

  const total = useMemo(() => {
    const acutalTotal = formik.values.values.reduce((a, b) => {
      return +a + (parseFloat(b?.total_amount === "" ? 0 : b?.total_amount) ?? 0);
    }, 0);

    const getDiscountValue = formik.values.values.reduce((a, b) => {
      return a + parseFloat(b?.discount ? b?.discount : "0");
    }, 0);

    const totalAmount = formik.values.values.reduce((a, b) => {
      const discountType = b?.discount_type ?? "%";
      if (discountType === "%") {
        const pct = parseFloat(b?.discount || 0) / 100;
        return a + (parseFloat(b?.total_amount || 0) * (1 - pct));
      }
      return a + (parseFloat(b?.total_amount || 0) - parseFloat(b?.discount || 0));
    }, 0);

    if (getDiscountValue > 0) {
      formik.setFieldValue("actual_total", totalAmount);
    } else {
      formik.setFieldValue("actual_total", acutalTotal);
    }
    formik.setFieldValue("current_total", totalAmount);
    return Number.isNaN(totalAmount) ? 0 : totalAmount;
  }, [formik.values.values]);
  const changeAmount = useMemo(() => {
    const newAmount =
      formik.values?.values[0].split_duration === "day"
        ? total / formik.values?.values[0].number_of_split
        : formik.values?.values[0].split_duration === "week"
          ? total / (formik.values?.values[0].number_of_split * 7)
          : formik.values?.values[0].split_duration === "month"
            ? total / (formik.values?.values[0].number_of_split * 30)
            : formik.values?.values[0].split_duration === "quarter"
              ? total / (formik.values?.values[0].number_of_split * 90)
              : formik.values?.values[0].split_duration === "year"
                ? total / (formik.values?.values[0].number_of_split * 365)
                : "";

    formik.setFieldValue("change", newAmount);
    return Number.isNaN(newAmount) ? 0 : newAmount;
  }, [formik.values.values]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };

  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <RightArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };

  useEffect(() => {
    async function fetchMyAPI() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      await FinanceService.getACcountNames(token, search)
        .then((res) => {
          if (res?.accounts) {
            res.accounts.map((item) => {
              item.label = item.family_name;
              item.value = item.account_id;
              return item;
            });
            setData(res?.accounts);
          }
          enableLoading(false);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }
    async function getLedgeraccounts() {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getLedgerAccountsForDonation(
        "donation",
        token
      );
      if (res?.ledgers) {
        setLedgers(res?.ledgers);
      }
      enableLoading(false);
    }
    getLedgeraccounts();
    fetchMyAPI();
  }, [search, getAccessTokenSilently]);
  const getLedgerSubLedgerListById = async (event) => {
    formik.setFieldValue(`values.${index}.Ledger`, {
      id: event.value,
      name: event.label,
      account_receivable: event?.account_receivable,
    });
    const ksubLedgers = ledgers?.find((item) => event.value === item._id);
    setSubLedgerOptions(ksubLedgers?.sub_ledgers);
    formik.setFieldValue(`values.${index}.SubLedger`, {
      id: "",
      name: "",
    });
    formik.setFieldValue(`values.${index}.tax`, event?.tex);
    if (formik.values.type !== "edit-charge") {
      formik.setFieldValue(`values.${index}.total_amount`, event?.default_amount);
    }
    formik.setFieldValue(`values.${index}.require_notes`, event?.notes);
    formik.setFieldValue(`convenient_fee`, event?.gateway_fee);
    formik.setFieldValue(`values.${index}.tax_type`, event?.taxType);
  };
  const onSubledgerChange = (e) => {
    if(!e) {
      formik.setFieldValue(`values.${index}.SubLedger`, {
        id: "",
        name: "",
      });
      const currentLedger = options?.find((item) => formik.values?.values?.[index]?.Ledger?.id === item.value);
      formik.setFieldValue(`values.${index}.tax`, currentLedger?.tex);
      if (formik.values.type !== "edit-charge") {
        formik.setFieldValue(`values.${index}.total_amount`, currentLedger?.default_amount);
      }
      formik.setFieldValue(`convenient_fee`, currentLedger?.gateway_fee);
      formik.setFieldValue(`values.${index}.require_notes`, currentLedger?.notes);
      formik.setFieldValue(`values.${index}.tax_type`, currentLedger?.taxType);
      return;
    }
    formik.setFieldValue(`values.${index}.SubLedger`, {
      id: e.value,
      name: e.label,
    });
    formik.setFieldValue(`values.${index}.tax`, e?.tex);
    if (formik.values.type !== "edit-charge") {
      formik.setFieldValue(`values.${index}.total_amount`, e?.default_amount);
    }
    formik.setFieldValue(`convenient_fee`, e?.gateway_fee);
    formik.setFieldValue(`values.${index}.require_notes`, e?.notes);
    formik.setFieldValue(`values.${index}.tax_type`, e?.taxType);
  };
  

  const options =
    ledgers &&
    ledgers?.map((item) => {
      return {
        label: item?.ledger_name,
        value: item?._id,
        tex: item?.amount_detuctible,
        default_amount: item?.default_amount,
        gateway_fee: item?.gateway_fee,
        notes: item?.notes,
        account_receivable: item?.account_receivable,
        taxType: item?.deductibleType || "%",
      };
    });
  const subLedgersList =
    subLedgerOptions &&
    subLedgerOptions?.map((item) => {
      return {
        label: item.sub_ledger_name,
        value: item._id,
        tex: item?.amount_detuctible,
        default_amount: item?.default_amount,
        gateway_fee: item?.gateway_fee,
        notes: item?.notes,
        taxType: item?.deductibleType || "%",
      };
    });

  const [calculatedAmount, setCalculatedAmount] = useState("00");
  let commingAmount = formik.values?.values?.[index]?.charge?.amount
    ? formik.values?.values?.[index]?.charge?.amount
    : formik?.values?.allData
      ? formik?.values?.allData[0].total_amount
      : formik.values?.values?.[index]?.total_amount
        ? formik.values?.values?.[index]?.total_amount
        : "";

  const getCommaSeperatedValue = (num) => {
    return (
      CheckFloatValue(parseFloat(num?.toString().replace(/,/g, "")))
        ?.toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",") ?? 0.0
    );
  };
  function convertUTCToLocalDate(date) {
    if (!date) {
      return date
    }
    date = new Date(date)
    date = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())
    return date
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }


  useEffect(() => {
    if (refresh === false) {
      const index = 0;
      formik.setFieldValue("type_of_charge", "charge");
      if (formik.values?.nextPayment === false && accountName === true) {
        formik.setFieldValue("note", "");
        formik.setFieldValue(`values.${index}.Ledger`, {
          id: "",
          name: "",
          account_receviable: "",
        });
        formik.setFieldValue(`values.${index}.SubLedger`, {
          id: "",
          name: "",
          account_receviable: "",
        });
        formik.setFieldValue(`values.${index}.due_date`, new Date());
        formik.setFieldValue(`values.${index}.tax`, "");
        formik.setFieldValue(`values.${index}.total_amount`, "");
        formik.setFieldValue(`values.${index}.require_notes`, "");
        formik.setFieldValue(`values.${index}.discount`, "");
        // formik.setFieldValue(`account_receviable`, "");
        formik.setFieldValue(`values.${index}.split_duration`, "");
        formik.setFieldValue(`values.${index}.number_of_split`, "");

        formik.setFieldValue(`values.${index}.is_splitted`, false);
        formik.setFieldValue(`values.${index}.isRecurring`, false);
        formik.setFieldValue("values.${index}.comment_checkbox", false);

      }
    }
  }, [refresh]);


  useEffect(() => {
    const amount = formik.values?.values?.[index]?.total_amount;
    if (amount === "0" || amount === 0) {
      formik.setFieldValue(`values.${index}.is_splitted`, false);
    }
  }, [formik.values?.values?.[index]?.total_amount])

  useEffect(() => {
    if (formik.values.values[index]?.isRecurring === false) {
      formik.setFieldValue(`values.${index}.recurring_duration`, "");
      formik.setFieldValue(`values.${index}.cycle`, "");
      setSelectCycle("");
      setShowShortCut(false);
      setDateRange([null, null]);
    }
  }, [formik.values.values[index]?.isRecurring]);

  // recurring start date follows the due date (same as Charge); in edit mode the
  // saved recurring dates are kept
  useEffect(() => {
    if (formik.values.type !== "edit-charge" && formik?.values?.values?.[index]?.due_date) {
      setDateRange([new Date(formik?.values?.values?.[index]?.due_date), null]);
    }
  }, [formik?.values?.values?.[index]?.due_date])

  // useEffect(() => {
  //   if (formik.values.values[index]?.isRecurring) {
  //     formik.setFieldValue(`values.${index}.due_date`, new Date());
  //     convertLocalToUTCDate(new Date(), `values.${index}.due_date`);
  //   }

  // }, [formik.values.values[index]?.isRecurring])
  

  const disabledInstallment = useCallback(() => {
    if(formik.values.values[index]?.ChargeStatus === "close" && (+formik?.values?.actual_total - (+formik?.values?.totalPaid || 0)) <= 0
    || formik.values.values[index]?.ChargeStatus === "close" && (+formik?.values?.actual_total - +formik?.values?.current_amount) <= 0) {
      return true;
    }
    return false;
  }, [formik?.values?.actual_total, formik?.values?.totalPaid, formik?.values?.current_amount]);

  const disabledInstallmentPayment = disabledInstallment();


  return (
    <div className="renderd-comp">
      <form
        onSubmit={formik.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        <div className="charge-tab donation-tab col-sm-12 px-sm-15 pt-10 pb-3 ">
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              <div
                className="form-group"
                style={{
                  zIndex: "1111",
                }}
              >
                <LabelField mandatory title={"Account Name"} />
                <div style={formik.values.type === "edit-charge" ? { cursor: "not-allowed" } : {}}>
                <Select
                  {...{
                    formik,
                    name: `account_name`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={data}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(value) => {
                    formik.setFieldValue(`account_name`, {
                      id: value._id,
                      name: value.label,
                    });
                    setAccountName({
                      id: value._id,
                      name: value.label,
                    });
                  }}
                  value={
                    accountTransaction
                      ? {
                        label: accountTransaction?.family_name,
                        value: accountTransaction?._id,
                      }
                      : formik.values?.account_name
                        ? {
                          label: formik.values?.account_name?.name,
                          value: formik.values?.account_name?.id,
                        }
                        : ""
                  }
                  components={{ DropdownIndicator }}
                  isDisabled={formik.values.type === "edit-charge" ? true : index > 0 || !!accountTransaction}
                />
                </div>
              </div>
            </Col>
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <LabelField mandatory title="Transaction Type" />
                <div className={
                  formik.values.type === "edit-charge" &&
                  (formik.values.values?.[index]?.charge_type === "credit_on_account" || formik.values.values?.[index]?.charge_type === "credit on account")
                    ? "disabledDiv charge-type"
                    : "charge-type"
                }>
                  {types.map((type, idx) => {
                    const isSelected = type === show;
                    const isCOASelected = show === "Credit On Account";
                    const isCOA = type === "Credit On Account";
                    const isEditMode = formik.values.type === "edit-charge";
                    const isDisabledOption = !isSelected && isEditMode && (isCOASelected || isCOA);
                    return <span
                      className={
                        type === "Credit On Account" ? "col-sm-6" : "col-sm-3"
                      }
                      style={
                        isSelected
                          ? { background: "#2555ef", color: "white" }
                          : isDisabledOption
                            ? { color: "#b0b0b0", cursor: "not-allowed" }
                            : {}
                      }
                      key={idx}
                      onClick={() => {
                        if (formik.values.type === "edit-charge") {
                          if (type === "Credit On Account") {
                            toastr.error("You can not change to Credit On Account");
                            return;
                          }
                          setShow(type);
                          formik.setFieldValue(`values.${index}.charge_type`, type.toLowerCase());
                        } else {
                          setShow(type);
                          setAccountName(true);
                          formik.setFieldValue(
                            `values.${index}.isRecurring`,
                            false,
                          );
                          formik.setFieldValue(
                            `values.${index}.is_splitted`,
                            false,
                          );
                          formik.setFieldValue(
                            `values.${index}.charge_type`,
                            type.toLowerCase()
                          );
                        }
                      }}
                      {...{
                        formik,
                        value: formik.values.values?.[index]?.charge_type,
                      }}
                    >
                      {type}
                    </span>;
                  })}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <InputField
                    mandatory
                    type="text"
                    {...{
                      formik,
                      title: "Donor name",
                      name: `values.${index}.donation_donorName`,
                      placeholder: `Donor name`,
                      value: formik.values?.values?.[index]?.donation_donorName,
                    }}
                    handleChange={(e) => {
                      formik.setFieldValue(
                        `values.${index}.donation_donorName`,
                        e.target.value
                      );
                    }}
                  // onKeyDown={(e) =>
                  //   exceptThisSymbols.includes(e.key) && e.preventDefault()
                  // }
                />
              </div>
            </Col>
          </Row>
          {/* donation */}
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              {formik.values.type === "edit-charge" ? (
                <div className="form-group">
                  <LabelField title={"Date"} mandatory />
                  <div style={{ cursor: "not-allowed" }}>
                    <div style={{ pointerEvents: "none" }}>
                      <DatePicker
                        showIcon
                        placeholderText={placeholderFormat}
                        dateFormat={dateFormate}
                        selected={
                          formik.values.values?.[index]?.payment_date
                            ? convertUTCToLocalDate(formik.values.values?.[index]?.payment_date)
                            : null
                        }
                        onChange={(e) => {
                          formik.setFieldValue(`values.${index}.payment_date`, e);
                          convertLocalToUTCDate(e, `values.${index}.payment_date`);
                        }}
                        disabled={true}
                        customInput={
                          <MaskedInput
                            pipe={autoCorrectedDatePipe}
                            mask={dateTimeMask}
                            keepCharPositions={true}
                            guide={true}
                          />
                        }
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <DatePickerField
                  disabled={true}
                  mandatory="true"
                  {...{
                    formik,
                    name: `values.${index}.payment_date`,
                    title: "Date",
                    checkValidation: false,
                    value: formik.values.values?.[index]?.payment_date,
                  }}
                  value={formik.values.values?.[index]?.payment_date}
                  newDate={"newDate"}
                  financeDateFields="finance_datefield"
                />
              )}
            </Col>
            <Col className="col-12 col-md-5">
              <div className="form-group">
              <LabelField title={"Due Date"} mandatory />
              <DatePicker
                isClearable={formik.values.type === "edit-charge" ? false : true}
                showIcon
                disabled={formik?.values?.values?.[index]?.isRecurring && formik.values.type === "edit-charge" ? true : false}
                // disabled={formik.values.type === "edit-charge" ? true : false}
                placeholderText={placeholderFormat}
                dateFormat={dateFormate}
                minDate={formik.values.values[index]?.isRecurring && new Date()}
                selected={
                  formik?.values?.type === "edit-charge" && formik?.values?.values?.[index]?.isRecurring
                    ? (formik.values.values?.[index]?.recurringStart ? new Date(formik.values.values?.[index]?.recurringStart) : null)
                    : formik?.values?.values?.[index]?.due_date
                      ? convertUTCToLocalDate(formik?.values?.values?.[index]?.due_date)
                      : null
                }
                onChange={(e) => {
                  formik.setFieldValue(`values.${index}.due_date`, e);
                  convertLocalToUTCDate(e, `values.${index}.due_date`);
                }}
                customInput={
                  <MaskedInput
                    pipe={autoCorrectedDatePipe}
                    mask={dateTimeMask}
                    keepCharPositions={true}
                    guide={true}
                  />
                }
              />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <LabelField mandatory title={"Ledger Account"} />
                <Select
                  {...{
                    formik,
                    name: `values.${index}.Ledger`,
                    checkValidation: false,
                  }}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={options}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(event) => {
                    if (formik.values.type === "edit-charge") {
                      setPendingLedger(event);
                      setShowLedgerConfirm(true);
                    } else {
                      getLedgerSubLedgerListById(event);
                    }
                  }}
                  value={{
                    label: formik.values?.values?.[index]?.Ledger ? (
                      formik.values?.values?.[index]?.Ledger?.name
                    ) : (
                      <span style={{ color: "#b5b5c3" }}> Select</span>
                    ),
                    value: formik.values?.values?.[index]?.Ledger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
            <Col className="col-12 col-md-5">
              <div className="form-group">
                <LabelField title={"Sub-Ledger Account"} />
                <Select
                  {...{
                    formik,
                    name: `values.${index}.SubLedger`,
                    checkValidation: false,
                  }}
                  isClearable={formik.values?.values?.[index]?.SubLedger?.id ?? false}
                  onInputChange={(text) => searchAction(text)}
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  options={subLedgersList}
                  isLoading={loading}
                  styles={colourStyles}
                  onChange={(e) => {
                    if (formik.values.type === "edit-charge") {
                      setPendingSubLedger(e);
                      setShowSubLedgerConfirm(true);
                    } else {
                      onSubledgerChange(e);
                    }
                  }}
                  value={{
                    label: formik.values?.values?.[index]?.SubLedger ? (
                      formik.values?.values?.[index]?.SubLedger?.name
                    ) : (
                      <span style={{ color: "#b5b5c3" }}> Select</span>
                    ),
                    value: formik.values?.values?.[index]?.SubLedger?.id,
                  }}
                  components={{ DropdownIndicator }}
                />
              </div>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-10">
            <Col className="col-12 col-md-5 d-flex">
              <Col className="col-sm-6 px-0">
                <InputField
                  type="number"
                  {...{
                    formik,
                    title: "Discount",
                    name: `values.${index}.discount`,
                    placeholder: "Discount",
                    value: formik.values?.values?.[index]?.discount
                      ? formik.values?.values?.[index]?.discount
                      : formik?.values?.allData
                        ? Math.round(formik?.values?.allData[0]?.discount * 1e2) / 1e2
                        : "",
                    checkValidation: true,
                  }}
                  style={{ backgroundColor: "#F3F6F9", border: "none" }}
                  onKeyDown={(e) => preventArrows(e)}
                  handleChange={(e) => {
                    const val = e.target.value;
                    const discountType = formik.values?.values?.[index]?.discount_type ?? "%";
                    const amount = +formik.values?.values?.[index]?.total_amount || 0;
                    if (discountType === "%" && +val > 100) {
                      toastr.error("Validation", "Discount should be 100% or less");
                      return;
                    }
                    if (discountType === "$" && +val > amount) {
                      toastr.error("Validation", "Discount is greater than amount");
                      return;
                    }
                    formik.setFieldValue(`values.${index}.discount`, val);
                  }}
                />
              </Col>
              <Col className="col-sm-6 price-type mt-6">
                <PriceType
                  value={
                    formik.values?.values?.[index]?.discount_type
                      ? formik.values?.values?.[index]?.discount_type
                      : "%"
                  }
                  handleClick={() => {}}
                  setFieldValue={formik.setFieldValue}
                  index={index}
                  discount={`values.${index}.discount`}
                  type={`values.${index}.discount_type`}
                />
              </Col>
            </Col>
            <Col className="col-12 col-md-5 d-flex justify-content-center">
              <Col className="col-sm-6 px-0">
                <InputField
                  type="number"
                  {...{
                    formik,
                    title: "Tax Deductible",
                    name: `values.${index}.tax`,
                    placeholder: "Tax",
                    value: formik.values?.values?.[index]?.tax ?? "0",
                  }}
                  onKeyDown={(e) => preventArrows(e)}
                  min="0"
                  disabled={formik.values.type === "edit-charge" ? true : false}
                  handleChange={(e) => {
                    formik.setFieldValue(
                      `values.${index}.tax`,
                      e.target.value.match(regex)[0]
                    );
                  }}
                />
              </Col>
              <Col className="col-12 col-md-5 price-type mt-6">
                {formik.values.type === "edit-charge" ? <></> : <PriceType
                  value={
                    formik.values?.values?.[index]?.tax_type
                      ? formik.values?.values?.[index]?.tax_type
                      : formik?.values?.allData[0].tax_type
                  }
                  handleClick={setTaxType}
                  setFieldValue={formik.setFieldValue}
                  index={index}
                  type={`values.${index}.tax_type`}
                />}
              </Col>
            </Col>
          </Row>
          <Row className="form-row sm-12 mb-4">
            <Col className="col-12 col-md-5">
              <InputField
                mandatory
                type="number"
                {...{
                  formik,
                  title: "Amount",
                  name: `values.${index}.total_amount`,
                  placeholder: "Charge Amount",
                  value: formik.values?.values?.[index]?.total_amount
                    ? formik.values?.values?.[index]?.total_amount
                    : formik?.values?.allData
                      ? formik?.values?.allData[0].total_amount
                      : "",
                  checkValidation: true,
                }}
                onKeyDown={(e) => preventArrows(e)}
                min="0"
                handleChange={(e) => {
                  formik.setFieldValue(
                    `values.${index}.total_amount`,
                    e.target.value.match(regex)[0]
                  );
                }}
              // onKeyDown={(e) =>
              //   exceptThisSymbols.includes(e.key) && e.preventDefault()
              // }
              />
            </Col>
            <Col className="col-12 col-md-5 offset-md-2 d-flex align-items-end pb-2 mt-9">
              <div
                className=""
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "nowrap",
                }}
              >
                <MyCheckbox
                  name={`values.${index}.is_splitted`}
                  split_amount
                  disabled={formik.values.type === "edit-charge" ? true : formik.values.values[index]?.ChargeStatus === "close" ? true : false}
                  title="Split"
                  handlechange={(event) => {
                    formik.setFieldValue(
                      `values.${index}.is_splitted`,
                      event.target.checked
                    );
                    formik.setFieldValue(`values.${index}.isRecurring`, false);
                    formik.setFieldValue(`values.${index}.isInstallmentTransaction`, false);
                    formik.setFieldValue(`values.${index}.installmentDetailsTransaction`, undefined);
                  }}
                  value={formik.values.values[index]?.is_splitted}
                  checked={formik.values?.values[index]?.is_splitted}
                />
                <InfoTooltip text={<>Break this <b>charge</b> into multiple <b>charges</b> spread over time, instead of billing the full amount at once.</>} style={{ marginLeft: '4px', marginRight: '8px', marginBottom: '8px' }} />
                <div
                  style={{ marginLeft: "0.25rem", display: "flex", alignItems: "center" }}
                  className={PaymentKey.toString() === "false" ? "disabledDiv" : formik.values.type === "edit-charge" ? "disabledDiv" : ""}
                >
                  <MyCheckbox
                    name={`values.${index}.isRecurring`}
                    disabled={PaymentKey.toString() === "false" ? true : formik.values.type === "edit-charge" ? true : false}
                    title="Recurring"
                    handlechange={(event) => {
                      formik.setFieldValue(
                        `values.${index}.isRecurring`,
                        event.target.checked
                      );
                      formik.setFieldValue(`values.${index}.is_splitted`, false);
                      formik.setFieldValue(`values.${index}.isInstallmentTransaction`, false);
                      formik.setFieldValue(`values.${index}.installmentDetailsTransaction`, undefined);
                    }}
                    value={formik.values.values[index]?.isRecurring}
                    checked={formik.values?.values[index]?.isRecurring}
                  />
                  <InfoTooltip text="Automatically bill this charge again on a repeating schedule, like a subscription. E.g., Monthly, every 3 months, or yearly." style={{ marginLeft: '4px', marginRight: '8px', marginBottom: '8px' }} />
                </div>
                {enableInstallments && (
                  <div
                    style={{ marginLeft: "0.25rem", display: "flex", alignItems: "center" }}
                    className={!formik.values.type === "edit-charge" && disabledInstallmentPayment ? "disabledDiv" : ""}
                  >
                    <MyCheckbox
                      name={`values.${index}.isInstallmentTransaction`}
                      title="Allow Installments"
                      handlechange={(event) => {
                        formik.setFieldValue(
                          `values.${index}.isInstallmentTransaction`,
                          event.target.checked
                        );
                        formik.setFieldValue(`values.${index}.is_splitted`, false);
                        formik.setFieldValue(`values.${index}.isRecurring`, false);
                      }}
                      value={formik.values.values[index]?.isInstallmentTransaction}
                      checked={formik.values?.values[index]?.isInstallmentTransaction}
                      disabled={formik.values.type === "edit-charge" ? false : disabledInstallmentPayment}
                    />
                    <InfoTooltip text="Let the payer spread this charge across multiple scheduled installments instead of paying it all at once. Only monthly installments are currently supported." useFixed style={{ marginLeft: '4px', marginRight: '8px', marginBottom: '8px' }} />
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <Col className="col px-0">
            {(formik.values.values[index]?.isInstallmentTransaction && enableInstallments) && (
              <AddInstallmentsPayment
                formik={formik}
                formikKey={"installmentDetailsTransaction"}
                onInstallmentChange={(value) => {
                  if(!value) {
                    formik.setFieldValue(`values.${index}.installmentDetailsTransaction.numberOfInstallment`, null); 
                    return;
                  }
                  formik.setFieldValue(`values.${index}.installmentDetailsTransaction.numberOfInstallment`, value?.value);
                }}
                onDateChange={(date) => {
                  formik.setFieldValue(`values.${index}.installmentDetailsTransaction.lastInstallmentDate`, date);
                  convertLocalToUTCDate(date, `values.${index}.installmentDetailsTransaction.lastInstallmentDate`);
                }}
                installmentValue={formik.values.values[index]?.installmentDetailsTransaction?.numberOfInstallment}
                dateValue={
                  formik.values.values[index]?.installmentDetailsTransaction?.lastInstallmentDate &&
                  convertUTCToLocalDate(formik.values.values[index]?.installmentDetailsTransaction?.lastInstallmentDate)
                }
                manageFromOutside={true}
                disabled={disabledInstallmentPayment}
              />
            )}
            {formik.values.values[index]?.isRecurring && (
              <Row>
                <div className="col-sm-4 mt-4">
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <LabelField title="Billing Period" mandatory />
                    <InfoTooltip text="How often this charge repeats. E.g., Monthly, Every 3 months, Yearly." style={{ marginBottom: '8px' }} />
                  </div>

                  <Select
                    onInputChange={(text) => searchAction(text)}
                    classNamePrefix="react-select"
                    formatOptionLabel={formatOptionLabel}
                    options={DurationValues}
                    isLoading={loading}
                    styles={colourStyles}
                    onChange={(value) => {
                      if (formik.values.values?.[index]?.due_date) {
                        formik.setFieldValue(
                          `values.${index}.recurring_duration`,
                          {
                            id: value.value,
                            name: value.label,
                            number: value.number,
                          }
                        );
                      } else {
                        toastr.error("You need to select due date first.")
                      }
                    }}
                    value={
                      formik.values.values?.[index]?.recurring_duration
                        ? {
                          label: formik.values.values?.[index]?.recurring_duration?.name,
                          value: formik.values.values?.[index]?.recurring_duration?.id,
                        }
                        : ""
                    }
                    components={{ DropdownIndicator }}
                    isDisabled={PaymentKey.toString() === "false" ? true : formik?.values?.values?.[index]?.isRecurring && formik.values.type === "edit-charge" ? true : false}
                  />
                </div>
                {formik.values.values?.[index]?.recurring_duration ? (
                  <>
                  {showShortCut && (
                    <div className="col-sm-3 mt-4">
                      <LabelField title="Billing Cycle" mandatory />
                      <div className="shortcuts_style_inline">
                        {ShortcutsArr.map((item, index_key) => (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              formik.setFieldValue(`values.${index}.cycle`, item);
                              setSelectCycle(item);
                            }}
                            key={index_key}
                          >
                            {item?.value === "forever" ? "Forever" : item?.value}{" "}{item?.name !== "Forever" && <span style={{ color: 'black' }}>{item?.value === "1" ? 'cycle' : 'cycles'}</span>}
                          </div>
                        ))}
                        {customBol ? (
                          <div onClick={() => {}} style={{ display: "flex" }}>
                            <input
                              style={{ width: "60px", marginRight: "4px", borderRadius: "5px", border: "0.6px solid gray" }}
                              placeholder={"cycles"}
                              type={"number"}
                              onChange={(event) => {
                                formik.setFieldValue(`values.${index}.customValue`, event.target.value);
                              }}
                            />
                            <button
                              style={{ borderRadius: "5px", border: "0.7px solid gray", background: "white", fontWeight: "bold" }}
                              onClick={() => {
                                formik.setFieldValue(`values.${index}.cycle`, { name: "custom", value: formik.values.values?.[index]?.customValue });
                                setSelectCycle({ name: "custom", value: formik.values.values?.[index]?.customValue });
                                setCustomBol(false);
                              }}
                            >
                              Apply
                            </button>
                          </div>
                        ) : (
                          <div style={{ cursor: "pointer" }} onClick={() => setCustomBol(true)}>
                            {"custom"}
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {formik.values.values?.[index]?.cycle && (
                  <div className={PaymentKey.toString() === "false" ? "disabledDiv col-sm-4 mt-4" : formik.values.type === "edit-charge" ? "disabledDiv col-sm-4 mt-4" : "col-sm-4 mt-4"}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                      <LabelField title={"Start/End Date"} mandatory />
                      <InfoTooltip text="The date range this recurring charge runs across, based on the selected billing cycle." style={{ marginBottom: '8px' }} />
                    </div>
                    <div
                      onClick={() => {
                        if (formik.values.type !== "edit-charge") {
                          setShowShortCut(true);
                        }
                      }}
                    >
                      <DatePicker
                        style={colourStyles}
                        selectsRange={true}
                        startDate={formik?.values?.type === "edit-charge" ? (formik.values.values?.[index]?.recurringStart ? new Date(formik.values.values?.[index]?.recurringStart) : null) : startDate}
                        endDate={formik?.values?.type === "edit-charge" ? (formik.values.values?.[index]?.cycle === "forever" || formik.values.values?.[index]?.cycle?.value === "forever") ? "" : (formik.values.values?.[index]?.recurringEnd ? new Date(formik.values.values?.[index]?.recurringEnd) : null) : endDate}
                        minDate={new Date()}
                        maxDate={endDate === null ? startDate : endDate}
                        onChange={(update) => {
                          setDateRange(update);
                        }}
                        disabled={true}
                        wrapperClassName="date-picker-custom"
                        placeholderText={`${placeholderFormat} -- ${placeholderFormat}`}
                        dateFormat={dateFormate}
                      />
                    </div>
                  </div>
                  )}
                  </>
                ) : null}
              </Row>
            )}
            {formik.values.values[index]?.is_splitted && (
              <Row className="form-row">
                <div className="col-12 col-md-5">
                  <SelectField
                    style={{ background: "#F3F6F9" }}
                    {...{
                      formik,
                      name: `values.${index}.split_duration`,
                      items: ["day", "week", "month", "quarter", "year"],
                      placeholder: "Select",
                      value: formik.values.values?.[index]?.split_duration ? (
                        <span style={{ color: "black" }}>
                          {formik.values.values?.[index]?.split_duration}
                        </span>
                      ) : (
                        "Select"
                      ),
                    }}
                    // disabled={selectedStatus === "close" ? true : false}
                    // disabled={formik.values.split_amount && formik.values.type === "edit-charge" ? true : false}
                    // disabled={formik.values.actual_total > formik.values.current_amount ? false : formik.values.split_amount && formik.values.type === "edit-charge" ? true : false}
                    // disabled={formik.values.split_amount ? true : false}

                    onClick={(data) =>
                      formik.setFieldValue(
                        `values.${index}.split_duration`,
                        data
                      )
                    }
                  />
                </div>
                {formik.values.values?.[index]?.split_duration ? (
                  <div className="col-12 col-md-5 offset-md-2">
                    <div style={{ position: "relative" }}>
                    <InputField
                      type="number"
                      {...{
                        formik,
                        title: "",
                        name: `values.${index}.number_of_split`,
                        placeholder: "0",
                        value: formik.values?.values?.[index]?.number_of_split,
                        checkValidation: true,
                      }}
                      onKeyDown={(e) => preventArrows(e)}
                      handleChange={(e) => {
                        const newValue = parseInt(e.target.value);
                        formik.setFieldValue(
                          `values.${index}.number_of_split`,
                          newValue
                        );
                      }}
                    // disabled={selectedStatus === "close" ? true : false}
                    // disabled={formik.values.split_amount ? true : false}
                    // disabled={formik.values.split_amount && formik.values.type === "edit-charge" ? true : false}
                    // disabled={formik.values.actual_total > formik.values.current_amount ? false : formik.values.split_amount && formik.values.type === "edit-charge" ? true : false}
                    />
                    <div className="placeholder-div" style={{ top: 0, bottom: 0, display: "flex", alignItems: "center", transform: "none" }}>
                      <p>
                        {formik.values.values?.[index]?.split_duration ??
                          "year"}
                      </p>
                    </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </Row>
            )}
          </Col>
          
          <Row className="form-row sm-12 mb-0 mt-10">
            <Col className="col-sm-12 px-0">
              <TextareaField
                mandatory={formik?.values?.values?.[index]?.require_notes}
                {...{
                  formik,
                  title: "Add Note",
                  name: `values.${index}.note`,
                  placeholder: "Note text",
                  style: { resize: "none" },
                  checkValidation: true,
                  onChange: (value) => {
                    formik.setFieldValue(`values.${index}.note`, value);
                  },
                }}
                defaultValue={
                  formik?.values?.note ??
                  formik?.values?.allData?.[0]?.comment_invoice?.note
                }
              />
            </Col>
          </Row>
          <div className="mb-5" style={{ display: 'flex', alignItems: 'center' }}>
            <MyCheckbox
              {...{
                formik,
                title: "Add Note",
                name: `values.${index}.comment_checkbox`,
              }}
              title="Comment on invoice"
              handleSubmit
              handlechange={(event) => {
                formik.setFieldValue(
                  `values.${index}.comment_checkbox`,
                  event.target.checked
                );
              }}
              checked={formik?.values?.values?.[index]?.comment_checkbox}
            />
            <InfoTooltip text="Show the note above on the invoice sent to the payer, instead of keeping it internal only." style={{ marginLeft: '6px', marginBottom: '8px' }} />
          </div>
          <hr className="mt-10 mb-7" />
          <div className="d-flex justify-content-end ">
            <p className="charge-total mb-0">
              Total: {currency}
              {formik.values?.values?.[index]?.total_amount
                ? numberFormat({number:+formik.values?.current_total, decimal: 2, style: 'decimal'})
                : "0.00"}
            </p>
            {formik.values?.values?.length === 1 ? (
              ""
            ) : (
              <div className="mt-2 ml-5">
                <a className="text-primary" onClick={() => removeCharge(index)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-trash"
                    viewBox="0 0 16 16"
                  >
                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path
                      fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                    />
                  </svg>
                  <span className="ml-2">Remove Donation</span>
                </a>
              </div>
            )}
          </div>

          {formik.values.type !== "edit-charge" && (
          <div className="mb-5">
            <MyCheckbox
              title="Give in honor or memory of someone"
              checked={formik.values?.values?.[index]?.applyTributeInfo}
              handlechange={() => {
                formik.setFieldValue(
                  `values.${index}.applyTributeInfo`,
                  !formik.values?.values?.[index]?.applyTributeInfo
                );
              }}
            />
          </div>
          )}
          {(formik.values.type !== "edit-charge" && formik.values?.values?.[index]?.applyTributeInfo) && <div className="mb-4">
            <FinanceAccordion
              body={<TributeInformation data={data} index={index}/> }
              header={<>Tribute information</>}
              expanded={true}
              formik={formik}
            
            />
          </div>}
        </div>
      </form>

      <AlertDialog
        open={showLedgerConfirm}
        onDecline={() => { setShowLedgerConfirm(false); setPendingLedger(null); }}
        onAccept={() => {
          setShowLedgerConfirm(false);
          if (pendingLedger) getLedgerSubLedgerListById(pendingLedger);
          setPendingLedger(null);
        }}
        title={"Update Ledger"}
        acceptBtnText={"Update"}
        description={
          <div style={{ textAlign: 'left' }}>
            <p style={{ marginBottom: '8px' }}>By clicking update you are aware and agree to the below:</p>
            <ul style={{ paddingLeft: '18px', marginBottom: 0 }}>
              <li style={{ marginBottom: '6px' }}>All related transactions and documents will be updated with the new ledger name.</li>
              <li>Your accounting software (if connected) will not be updated. In order to keep the data accurate, you will need to update it manually.</li>
            </ul>
          </div>
        }
      />

      <AlertDialog
        open={showSubLedgerConfirm}
        onDecline={() => { setShowSubLedgerConfirm(false); setPendingSubLedger(undefined); }}
        onAccept={() => {
          setShowSubLedgerConfirm(false);
          onSubledgerChange(pendingSubLedger);
          setPendingSubLedger(undefined);
        }}
        title={"Update Sub-Ledger"}
        acceptBtnText={"Update"}
        description={
          <div style={{ textAlign: 'left' }}>
            <p style={{ marginBottom: '8px' }}>By clicking update you are aware and agree to the below:</p>
            <ul style={{ paddingLeft: '18px', marginBottom: 0 }}>
              <li style={{ marginBottom: '6px' }}>All related transactions and documents will be updated with the new ledger name.</li>
              <li>Your accounting software (if connected) will not be updated. In order to keep the data accurate, you will need to update it manually.</li>
            </ul>
          </div>
        }
      />
    </div>
  );
};

export default Donation;